import { jsPDF } from "jspdf";

const hexToRgb = (hex) => { const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || ""); return m ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)] : [14, 124, 130]; };
const loadImg = (url) => new Promise((res) => {
  if (!url) return res(null);
  const img = new Image(); img.crossOrigin = "anonymous";
  img.onload = () => { try { const cv = document.createElement("canvas"); cv.width = img.naturalWidth; cv.height = img.naturalHeight; cv.getContext("2d").drawImage(img, 0, 0); res({ data: cv.toDataURL("image/png"), w: img.naturalWidth, h: img.naturalHeight }); } catch { res(null); } };
  img.onerror = () => res(null); img.src = url;
});

export async function exportCandidateReport(c, job, brand) {
  const primary = hexToRgb(brand?.brand_primary);
  const logo = await loadImg(brand?.brand_logo_url);
  const pdf = new jsPDF("p", "pt", "a4");
  const W = pdf.internal.pageSize.getWidth();
  const M = 48; let y = 60;
  const write = (txt, { size = 11, bold = false, color = [40, 40, 40], gap = 6 } = {}) => {
    pdf.setFont("helvetica", bold ? "bold" : "normal"); pdf.setFontSize(size); pdf.setTextColor(...color);
    pdf.splitTextToSize(String(txt), W - M * 2).forEach((l) => { if (y > 790) { pdf.addPage(); y = 60; } pdf.text(l, M, y); y += size + 4; });
    y += gap;
  };
  const rule = () => { if (y > 770) { pdf.addPage(); y = 60; } pdf.setDrawColor(220); pdf.line(M, y, W - M, y); y += 14; };
  const list = (title, items) => { if (!(items || []).length) return; write(title, { size: 10, bold: true, gap: 2 }); items.forEach((s) => { write(`• ${s.point}`, { size: 10, gap: 1 }); if (s.evidence) write(`     ${s.evidence}`, { size: 8, color: [130, 130, 130], gap: 2 }); }); };
  if (logo) { const lw = 84; const lh = Math.min((logo.h * lw) / logo.w, 40); pdf.addImage(logo.data, "PNG", W - M - lw, 40, lw, lh); }
  write(brand?.brand_name || "HireStream", { size: 10, bold: true, color: primary, gap: 2 });
  write("Candidate Assessment Report", { size: 20, bold: true, color: primary });
  write(c.name, { size: 14, bold: true });
  write(`${c.email}${job?.title ? `  ·  ${job.title}` : ""}`, { size: 9, color: [120, 120, 120] });
  write(`Generated ${new Date().toLocaleString()}`, { size: 9, color: [120, 120, 120], gap: 10 });
  rule();
  write(`Overall score: ${c.overall_score ?? "—"}  (${c.confidence || "—"} confidence)`, { size: 13, bold: true, color: primary });
  const sc = [];
  if (c.objective_score != null) sc.push(`Objective MCQs: ${c.objective_score}%`);
  if (c.subjective_score != null) sc.push(`Situational: ${c.subjective_score}%`);
  if (sc.length) write(sc.join("   ·   "), { size: 10, gap: 10 });
  if (c.debrief) {
    rule(); write("AI debrief", { size: 12, bold: true, color: primary });
    if (c.debrief.recommendation) write(`Recommendation: ${String(c.debrief.recommendation).toUpperCase()}`, { size: 10, bold: true });
    if (c.debrief.headline) write(c.debrief.headline, { size: 11, bold: true });
    if (c.debrief.summary) write(c.debrief.summary, { size: 10, color: [80, 80, 80] });
    list("Strengths", c.debrief.strengths);
    list("Areas to probe", c.debrief.improvements);
  }
  if ((c.competencies || []).length) {
    rule(); write("Competency scores", { size: 12, bold: true, color: primary });
    c.competencies.forEach((comp) => write(`• ${comp.name}: ${comp.score ?? "—"}${comp.weight ? `  (weight ${comp.weight}%)` : ""}`, { size: 10, gap: 2 }));
  }
  if ((c.question_breakdown || []).length) {
    rule(); write("Per-question breakdown", { size: 12, bold: true, color: primary });
    c.question_breakdown.forEach((b, i) => {
      write(`Q${i + 1}. ${b.prompt}`, { size: 10, bold: true, gap: 2 });
      write(`Answer: ${b.answer || "— blank —"}`, { size: 9, color: [90, 90, 90], gap: 1 });
      if (b.format === "multiple_choice") write(b.is_correct ? "Result: Correct" : `Result: Incorrect — correct answer: ${b.correct_answer || "—"}`, { size: 9, color: b.is_correct ? [16, 140, 80] : [190, 60, 60], gap: 3 });
      else if (b.score != null) write(`Score: ${b.score}/100${b.note ? ` — ${b.note}` : ""}`, { size: 9, color: [90, 90, 90], gap: 3 });
    });
  }
  if (c.rationale) { rule(); write("Scoring rationale", { size: 12, bold: true, color: primary }); write(c.rationale, { size: 9, color: [90, 90, 90] }); }
  y += 6; write(`Advisory only — AI recommends, humans decide. ${brand?.brand_name || "HireStream"}.`, { size: 8, color: [150, 150, 150] });
  pdf.save(`assessment-${(c.name || "candidate").replace(/\s+/g, "-").toLowerCase()}.pdf`);
}
